import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ParkerStateService } from '../services/parker-state.service';
import { ParkerService, ParkerSpaceEntitlementDto, ParkerZoneEntitlementDto, ParkingEntitlementStatus } from '../../api/gen';

@Component({
  selector: 'app-entitlements',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './entitlements.component.html',
  styleUrls: ['./entitlements.component.scss']
})
export class EntitlementsComponent implements OnInit {
  readonly state = inject(ParkerStateService);
  private readonly parkerService = inject(ParkerService);

  ngOnInit(): void {
    if (this.state.entitlements().length === 0) {
      this.state.isEntitlementsLoading.set(true);
      this.parkerService.parkerMeParkingEntitlementsGet().subscribe({
        next: (entitlements) => {
          this.state.entitlements.set(entitlements ?? []);
          this.state.isEntitlementsLoading.set(false);
        },
        error: () => {
          this.state.isEntitlementsLoading.set(false);
        }
      });
    }
  }

  isIncluded(status?: ParkingEntitlementStatus): boolean {
    return status === ParkingEntitlementStatus.Included || (status as any) === 'Included' || (status as any) === 0;
  }

  isNotIncluded(status?: ParkingEntitlementStatus): boolean {
    return status === ParkingEntitlementStatus.NotIncluded || (status as any) === 'NotIncluded' || (status as any) === 1;
  }

  isNotAvailable(status?: ParkingEntitlementStatus): boolean {
    return status === ParkingEntitlementStatus.NotAvailable || (status as any) === 'NotAvailable' || (status as any) === 2;
  }

  getStatusLabelKey(status?: ParkingEntitlementStatus): string {
    if (this.isIncluded(status)) return 'ENTITLEMENTS_PAGE.INCLUDED';
    if (this.isNotIncluded(status)) return 'ENTITLEMENTS_PAGE.EXTRA';
    return 'ENTITLEMENTS_PAGE.NOT_AVAILABLE';
  }
}
